import React from 'react';
import './card.scss';
import Card from '@material-ui/core/Card';

const AgilityCard = ({ ...props }) => (
  <Card classes={{ root: 'card' }} {...props} />
);

export default AgilityCard;
